<template>
  <div>
    <div class="breadcrumb d-flex justify-content-between align-items-center">
      <h1 style="color: #ac8400">Loyalty Dashboard</h1>
      <button class="btn btn-primary btn-rounded" @click="openExportModal">
        Export Reports
      </button>
    </div>
    <div class="separator-breadcrumb border-top"></div>

    <div
      v-if="exportModal"
      class="modal fade show"
      tabindex="-1"
      role="dialog"
      aria-hidden="false"
      style="display: block; background-color: rgba(0, 0, 0, 0.5)"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content p-4">
          <div class="modal-body text-center">
            <h5 class="modal-title text-primary mb-3">Export Reports</h5>
            <div class="row">
              <div class="col-6">
                <TextInput
                  label="Date from:"
                  type="date"
                  :modelValue="export_date_from"
                  required
                  :errorMessage="exportFromMessage"
                  :onChange="(e) => (export_date_from = e.target.value)"
                />
              </div>
              <div class="col-6">
                <TextInput
                  label="Date to:"
                  type="date"
                  :modelValue="export_date_to"
                  required
                  :errorMessage="exportToMessage"
                  :onChange="(e) => (export_date_to = e.target.value)"
                />
              </div>
            </div>
            <small class="text-muted d-block mb-2">
              Leave both blank to export the current month.
            </small>
            <small v-if="isExporting" class="text-muted d-block">
              Generating reports, this may take a few minutes...
            </small>
          </div>
          <div class="d-flex justify-content-center px-3 py-2">
            <button
              type="button"
              class="btn btn-outline-primary mr-2"
              :disabled="isExporting"
              @click="exportModal = false"
            >
              Close
            </button>
            <button
              type="button"
              class="btn btn-primary"
              :disabled="isExporting"
              @click="downloadReports"
            >
              {{ isExporting ? "Generating..." : "Download" }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Takaful Brunei -->
    <div class="row">
      <div class="col-lg-4 col-md-4 col-12">
        <!-- <button @click="clickme(index)">clickme</button> -->
        <div class="card mb-4">
          <div class="card-body">
            <!-- Title -->
            <h3 style="color: #ac8400">Registered Vendors</h3>

            <br />

            <div class="row">
              <div class="col">
                <!-- Verified -->
                <h5 class="mb-2 text-muted">Active</h5>
                <p class="mb-1 text-30 font-weight-light" style="color: #000">
                  {{ regVendor.active }}
                </p>
                <div class="progress mb-1" style="height: 4px">
                  <div
                    class="progress-bar"
                    style="width: 100%; color: #ac8400"
                    role="progressbar"
                    aria-valuenow="0"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                </div>
              </div>

              <div class="col">
                <!-- Verified -->
                <h5 class="mb-2 text-muted">Inactive</h5>
                <p class="mb-1 text-30 font-weight-light" style="color: #000">
                  {{ regVendor.inactive }}
                </p>
                <div class="progress mb-1" style="height: 4px">
                  <div
                    class="progress-bar"
                    style="width: 100%"
                    role="progressbar"
                    aria-valuenow="0"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                </div>
              </div>

              <div class="col">
                <!-- Total -->
                <h5 class="mb-2 text-muted">Total</h5>
                <p class="mb-1 text-30 font-weight-light" style="color: #000">
                  {{ regVendor.active + regVendor.inactive }}
                </p>
                <div class="progress mb-1" style="height: 4px">
                  <div
                    class="progress-bar"
                    style="width: 100%"
                    role="progressbar"
                    aria-valuenow="0"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-4 col-md-4 col-12">
        <div class="card mb-4">
          <div class="card-body">
            <!-- Title -->
            <h3 style="color: #ac8400">Redeemed Points</h3>

            <br />

            <div class="row">
              <div class="col">
                <h5 class="mb-2 text-muted">Vendors</h5>
                <p class="mb-1 text-30 font-weight-light" style="color: #000">
                  {{ formatNumber(redeem.vendors) }}
                </p>
                <div class="progress mb-1" style="height: 4px">
                  <div
                    class="progress-bar"
                    style="width: 100%"
                    role="progressbar"
                    aria-valuenow="0"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                </div>
              </div>

              <div class="col">
                <h5 class="mb-2 text-muted">Charity</h5>
                <p class="mb-1 text-30 font-weight-light" style="color: #000">
                  {{ formatNumber(redeem.charity) }}
                </p>
                <div class="progress mb-1" style="height: 4px">
                  <div
                    class="progress-bar"
                    style="width: 100%"
                    role="progressbar"
                    aria-valuenow="0"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-4 col-md-4 col-12">
        <div class="card mb-4">
          <div class="card-body">
            <!-- Title -->
            <h3 style="color: #ac8400">TBM Points</h3>

            <br />

            <div class="row">
              <div class="col">
                <h5 class="mb-2 text-muted">Total Points Earned</h5>
                <p class="mb-1 text-30 font-weight-light" style="color: #000">
                  {{ formatNumber(tbm_points.total_earned) }}
                </p>
                <div class="progress mb-1" style="height: 4px">
                  <div
                    class="progress-bar"
                    style="width: 100%"
                    role="progressbar"
                    aria-valuenow="0"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                </div>
              </div>

              <div class="col">
                <h5 class="mb-2 text-muted">Points Expired</h5>
                <p class="mb-1 text-30 font-weight-light" style="color: #000">
                  {{ formatNumber(tbm_points.total_expired) }}
                </p>
                <div class="progress mb-1" style="height: 4px">
                  <div
                    class="progress-bar"
                    style="width: 100%"
                    role="progressbar"
                    aria-valuenow="0"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                </div>
              </div>

              <div class="col">
                <h5 class="mb-2 text-muted">Points Deleted</h5>
                <p class="mb-1 text-30 font-weight-light" style="color: #000">
                  {{ formatNumber(tbm_points.total_deleted_points) }}
                </p>
                <div class="progress mb-1" style="height: 4px">
                  <div
                    class="progress-bar"
                    style="width: 100%"
                    role="progressbar"
                    aria-valuenow="0"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End of Takaful Brunei -->

    <div class="row">
      <div class="col-lg-4 col-md-6 col-12">
        <!-- TBA -->
        <!-- <h3 style="color: #78BE20; margin-bottom: 20px;">Takaful Brunei Am (TBA)</h3> -->
        <div class="row">
          <div class="col">
            <div class="card mb-4">
              <div class="card-body">
                <!-- Title -->
                <h3 style="color: #ac8400">Vendor Banner Request</h3>

                <br />

                <!-- Pending -->
                <h5 class="mb-2 text-muted">Pending</h5>
                <p class="mb-1 text-30 font-weight-light" style="color: #000">
                  {{ vendorReq.pendings }}
                </p>
                <div class="progress mb-1" style="height: 4px">
                  <div
                    class="progress-bar"
                    style="width: 100%"
                    role="progressbar"
                    aria-valuenow="0"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                </div>

                <br />

                <!-- Completed -->
                <h5 class="mb-2 text-muted">Completed</h5>
                <p class="mb-1 text-30 font-weight-light" style="color: #000">
                  {{ vendorReq.completed }}
                </p>
                <div class="progress mb-1" style="height: 4px">
                  <div
                    class="progress-bar"
                    style="width: 100%"
                    role="progressbar"
                    aria-valuenow="0"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                </div>

                <br />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-4 col-md-6 col-12">
        <!-- TBA -->
        <!-- <h3 style="color: #78BE20; margin-bottom: 20px;">Takaful Brunei Am (TBA)</h3> -->
        <div class="row">
          <div class="col">
            <div class="card mb-4">
              <div class="card-body">
                <!-- Title -->
                <h3 style="color: #ac8400">Vendor Product Request</h3>

                <br />

                <!-- Pending -->
                <h5 class="mb-2 text-muted">Pending</h5>
                <p class="mb-1 text-30 font-weight-light" style="color: #000">
                  {{ productReq.pendings }}
                </p>
                <div class="progress mb-1" style="height: 4px">
                  <div
                    class="progress-bar"
                    style="width: 100%"
                    role="progressbar"
                    aria-valuenow="0"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                </div>

                <br />

                <!-- Completed -->
                <h5 class="mb-2 text-muted">Completed</h5>
                <p class="mb-1 text-30 font-weight-light" style="color: #000">
                  {{ productReq.completed }}
                </p>
                <div class="progress mb-1" style="height: 4px">
                  <div
                    class="progress-bar"
                    style="width: 100%"
                    role="progressbar"
                    aria-valuenow="0"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                </div>

                <br />

                <!-- Remarks -->
                <h5 class="mb-2 text-muted">Remarks</h5>
                <p class="mb-1 text-30 font-weight-light" style="color: #000">
                  {{ productReq.remarks }}
                </p>
                <div class="progress mb-1" style="height: 4px">
                  <div
                    class="progress-bar"
                    style="width: 100%"
                    role="progressbar"
                    aria-valuenow="0"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                </div>

                <br />

                <!-- Total -->
                <h5 class="mb-2 text-muted">Total</h5>
                <p class="mb-1 text-30 font-weight-light" style="color: #000">
                  {{ productReq.total }}
                </p>
                <div class="progress mb-1" style="height: 4px">
                  <div
                    class="progress-bar"
                    style="width: 100%"
                    role="progressbar"
                    aria-valuenow="0"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-4 col-md-6 col-12">
        <div class="card mb-4">
          <div class="card-body">
            <!-- Title -->
            <h3 style="color: #ac8400">Survey</h3>

            <br />

            <div class="row">
              <div class="col">
                <!-- Verified -->
                <h5 class="mb-2 text-muted">Active</h5>
                <p class="mb-1 text-30 font-weight-light" style="color: #000">
                  {{ survey.active }}
                </p>
                <div class="progress mb-1" style="height: 4px">
                  <div
                    class="progress-bar"
                    style="width: 100%"
                    role="progressbar"
                    aria-valuenow="0"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                </div>
              </div>

              <div class="col">
                <!-- Verified -->
                <h5 class="mb-2 text-muted">Inactive</h5>
                <p class="mb-1 text-30 font-weight-light" style="color: #000">
                  {{ survey.inactive }}
                </p>
                <div class="progress mb-1" style="height: 4px">
                  <div
                    class="progress-bar"
                    style="width: 100%"
                    role="progressbar"
                    aria-valuenow="0"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                </div>
              </div>

              <div class="col">
                <!-- Total -->
                <h5 class="mb-2 text-muted">Total</h5>
                <p class="mb-1 text-30 font-weight-light" style="color: #000">
                  {{ survey.total }}
                </p>
                <div class="progress mb-1" style="height: 4px">
                  <div
                    class="progress-bar"
                    style="width: 100%"
                    role="progressbar"
                    aria-valuenow="0"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card mb-4">
          <div class="card-body">
            <!-- Title -->
            <h3 style="color: #ac8400">Charity</h3>

            <br />

            <div class="row">
              <div class="col">
                <!-- Verified -->
                <h5 class="mb-2 text-muted">Active</h5>
                <p class="mb-1 text-30 font-weight-light" style="color: #000">
                  {{ charity.active }}
                </p>
                <div class="progress mb-1" style="height: 4px">
                  <div
                    class="progress-bar"
                    style="width: 100%"
                    role="progressbar"
                    aria-valuenow="0"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                </div>
              </div>

              <div class="col">
                <!-- Verified -->
                <h5 class="mb-2 text-muted">Inactive</h5>
                <p class="mb-1 text-30 font-weight-light" style="color: #000">
                  {{ charity.inactive }}
                </p>
                <div class="progress mb-1" style="height: 4px">
                  <div
                    class="progress-bar"
                    style="width: 100%; color: #ac8400"
                    role="progressbar"
                    aria-valuenow="0"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import { getAuthHeaders } from "@/services/UserTokenService";
import TextInput from "@/components/TextInput.vue";

export default {
  name: "dashboard-marketing",

  components: { TextInput },

  data() {
    return {
      exportModal: false,
      export_date_from: "",
      export_date_to: "",
      exportFromMessage: "",
      exportToMessage: "",
      isExporting: false,

      regVendor: {
        active: 0,
        inactive: 0,
      },

      vendorReq: {
        pendings: 0,
        completed: 0,
        total: 0,
      },

      productReq: {
        pendings: 0,
        completed: 0,
        remarks: 0,
        total: 0,
      },

      survey: {
        active: 0,
        inactive: 0,
        total: 0,
      },

      charity: {
        active: 0,
        inactive: 0,
        total: 0,
      },

      redeem: {
        vendors: 0,
        charity: 0,
      },

      tbm_points: {
        total_earned: 0,
        total_expired: 0,
        total_deleted_points: 0,
      },
    };
  },

  methods: {
    loadData() {
      this.loadVendors();
      this.redeemCharity();
      this.loadCounts();
      this.getAllPoints();
    },
    async loadVendors() {
      if (!this.checkToken()) {
        return;
      }

      try {
        let result = await axios.get(axios.lpsURL + "/vendor", {
          headers: {
            Authorization: "Bearer " + this.checkToken(),
          },
        });
        // this.regVendor = result.data.vendor;
        for (let i = 0; i < result.data.vendor.length; i++) {
          if (result.data.vendor[i].active_banner_link == null) {
            this.regVendor.inactive = this.regVendor.inactive + 1;
          } else {
            this.regVendor.active = this.regVendor.active + 1;
          }
        }
      } catch (error) {
        console.log(error);
      }
    },

    async redeemCharity() {
      if (!this.checkToken()) {
        return;
      }

      try {
        let result = await axios.get(
          axios.lpsURL + "/point/redeem/all?type=2",
          {
            headers: {
              Authorization: "Bearer " + this.checkToken(),
            },
          }
        );
        this.redeem.charity = result.data.total_points_redeemed;
      } catch (error) {
        console.log(error);
      }
    },

    async loadCounts() {
      if (!this.checkToken()) {
        return;
      }

      try {
        let result = await axios.get(
          axios.lpsURL + "/vendor_product/getCounts",
          {
            headers: {
              Authorization: "Bearer " + this.checkToken(),
            },
          }
        );
        this.vendorReq = result.data.vendors;
        this.productReq = result.data.products;
        this.survey = result.data.survey;
        this.charity = result.data.charity;
      } catch (error) {
        console.log(error);
      }
    },

    checkToken() {
      let token = localStorage.getItem("token");

      // check if has token
      if (token == null) {
        return false;
      }
      token = JSON.parse(token);
      token = token.access_token;
      return token;
    },

    async getAllPoints() {
      if (!this.checkToken()) {
        return;
      }

      try {
        let result = await axios.get(axios.lpsURL + "/point/all", {
          headers: {
            Authorization: "Bearer " + this.checkToken(),
          },
        });
        this.tbm_points.total_earned = result.data.total_points_earned;
        this.tbm_points.total_expired = result.data.expired_points;
        this.redeem.vendors = result.data.total_redeemed_points;
        this.tbm_points.total_deleted_points = result.data.total_deleted_points;
      } catch (error) {
        console.log(error);
      }
    },

    formatNumber(_number) {
      return parseFloat(_number).toLocaleString(undefined, {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      });
    },

    openExportModal() {
      this.export_date_from = "";
      this.export_date_to = "";
      this.exportFromMessage = "";
      this.exportToMessage = "";
      this.exportModal = true;
    },

    validateExportDates() {
      this.exportFromMessage = "";
      this.exportToMessage = "";

      // both blank is allowed -> backend defaults to the current month
      if (!this.export_date_from && !this.export_date_to) {
        return true;
      }

      if (!this.export_date_from) {
        this.exportFromMessage = "Start date is required.";
        return false;
      }

      if (!this.export_date_to) {
        this.exportToMessage = "End date is required.";
        return false;
      }

      if (new Date(this.export_date_from) > new Date(this.export_date_to)) {
        this.exportFromMessage = "Start date cannot be after end date.";
        return false;
      }

      return true;
    },

    suggestedZipName() {
      const today = new Date();
      const yyyy = today.getFullYear();
      const mm = String(today.getMonth() + 1).padStart(2, "0");
      const dd = String(today.getDate()).padStart(2, "0");
      return `${yyyy}${mm}${dd}.zip`;
    },

    async downloadReports() {
      if (!this.validateExportDates()) {
        return;
      }

      // showSaveFilePicker needs an active user gesture, which the report
      // generation fetch below (often 30s-several minutes) would consume by
      // the time it resolves - so the save location must be chosen up front.
      let fileHandle = null;
      if (window.showSaveFilePicker) {
        try {
          fileHandle = await window.showSaveFilePicker({
            suggestedName: this.suggestedZipName(),
            types: [
              {
                description: "Zip file",
                accept: { "application/zip": [".zip"] },
              },
            ],
          });
        } catch (pickerError) {
          if (pickerError.name == "AbortError") {
            return;
          }
          console.log("Failed to open save dialog:", pickerError);
          swal({
            icon: "error",
            text: "Could not open the save dialog. Please try again.",
          });
          return;
        }
      }

      this.isExporting = true;

      let response;
      try {
        const params = {};
        if (this.export_date_from) params.from = this.export_date_from;
        if (this.export_date_to) params.to = this.export_date_to;

        response = await axios.get("/export/all", {
          ...getAuthHeaders(),
          params,
          responseType: "blob",
        });
      } catch (error) {
        console.log("Failed to generate reports:", error);
        const message = await this.extractErrorMessage(error);
        swal({ icon: "error", text: message });
        this.isExporting = false;
        return;
      }

      try {
        if (fileHandle) {
          const writable = await fileHandle.createWritable();
          await writable.write(response.data);
          await writable.close();
        } else {
          let filename = this.suggestedZipName();
          const contentDisposition = response.headers["content-disposition"];
          if (contentDisposition) {
            const match = contentDisposition.match(/filename="?([^";]+)"?/);
            if (match && match[1]) {
              filename = match[1];
            }
          }

          const url = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);
        }

        this.exportModal = false;
        swal({
          icon: "success",
          text: "Reports downloaded successfully.",
        });
      } catch (error) {
        console.log("Failed to save the downloaded file:", error);
        swal({
          icon: "error",
          text: "The reports were generated but could not be saved. Please try again.",
        });
      } finally {
        this.isExporting = false;
      }
    },

    async extractErrorMessage(error) {
      const fallback = "Failed to generate reports. Please try again.";

      if (!error.response || !(error.response.data instanceof Blob)) {
        return fallback;
      }

      try {
        const text = await error.response.data.text();
        const json = JSON.parse(text);
        return json.message || fallback;
      } catch (parseError) {
        return fallback;
      }
    },
  },

  created() {
    this.loadData();
  },
};
</script>
